"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
export default function LightboxModal(t0) {
  const $ = _c(64);
  const {
    isOpen,
    images: t1,
    currentIndex: t2,
    sectionTitle: t3,
    onClose,
    onNavigate
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const images = t4;
  const currentIndex = t2 === undefined ? 0 : t2;
  const sectionTitle = t3 === undefined ? "" : t3;
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  let t5;
  let t6;
  if ($[2] !== currentIndex || $[3] !== images.length || $[4] !== isOpen || $[5] !== onClose || $[6] !== onNavigate) {
    t5 = () => {
      const handleKeyDown = e => {
        if (!isOpen) {
          return;
        }
        if (e.key === "Escape") {
          onClose();
        }
        if (e.key === "ArrowLeft") {
          onNavigate((currentIndex - 1 + images.length) % images.length);
        }
        if (e.key === "ArrowRight") {
          onNavigate((currentIndex + 1) % images.length);
        }
      };
      if (isOpen) {
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", handleKeyDown);
      } else {
        document.body.style.overflow = "";
      }
      return () => {
        document.body.style.overflow = "";
        window.removeEventListener("keydown", handleKeyDown);
      };
    };
    t6 = [isOpen, currentIndex, images.length, onClose, onNavigate];
    $[2] = currentIndex;
    $[3] = images.length;
    $[4] = isOpen;
    $[5] = onClose;
    $[6] = onNavigate;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  if (!isOpen || images.length === 0) {
    return null;
  }
  const currentImage = images[currentIndex];
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => {
      touchStartX.current = e_0.targetTouches[0].clientX;
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleTouchStart = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_1 => {
      touchEndX.current = e_1.targetTouches[0].clientX;
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleTouchMove = t8;
  let t9;
  if ($[11] !== currentIndex || $[12] !== images.length || $[13] !== onNavigate) {
    t9 = () => {
      if (!touchStartX.current || !touchEndX.current) {
        return;
      }
      const distance = touchStartX.current - touchEndX.current;
      if (distance > 40 && images.length > 1) {
        onNavigate((currentIndex + 1) % images.length);
      } else {
        if (distance < -40 && images.length > 1) {
          onNavigate((currentIndex - 1 + images.length) % images.length);
        }
      }
      touchStartX.current = null;
      touchEndX.current = null;
    };
    $[11] = currentIndex;
    $[12] = images.length;
    $[13] = onNavigate;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const handleTouchEnd = t9;
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0
    };
    t11 = {
      opacity: 1
    };
    t12 = {
      opacity: 0
    };
    t13 = {
      duration: 0.2
    };
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
  }
  const t14 = currentIndex + 1;
  let t15;
  if ($[19] !== images.length || $[20] !== t14) {
    t15 = <span className="px-2 py-0.5 sm:px-2.5 sm:py-1 text-[10px] sm:text-[11px] font-mono tracking-wider bg-[#DF6D2A]/20 text-[#DF6D2A] border border-[#DF6D2A]/30 rounded flex-shrink-0">{t14} / {images.length}</span>;
    $[19] = images.length;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== sectionTitle) {
    t16 = <span className="font-display text-[14px] sm:text-[18px] text-[#F4EFE6] font-medium truncate">{sectionTitle}</span>;
    $[22] = sectionTitle;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t15 || $[25] !== t16) {
    t17 = <div className="flex items-center gap-2.5 truncate mr-3">{t15}{t16}</div>;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <X size={18} strokeWidth={1.5} className="sm:w-5 sm:h-5" />;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== onClose) {
    t19 = <button onClick={onClose} aria-label="Close Lightbox" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border border-white/20 text-[#F4EFE6] hover:bg-[#DF6D2A] hover:border-[#DF6D2A] transition-colors flex-shrink-0">{t18}</button>;
    $[28] = onClose;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t17 || $[31] !== t19) {
    t20 = <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b border-white/10 bg-[#0F1C2E]/90 z-10">{t17}{t19}</div>;
    $[30] = t17;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== currentIndex || $[34] !== images.length || $[35] !== onNavigate) {
    t21 = images.length > 1 && <button onClick={() => onNavigate((currentIndex - 1 + images.length) % images.length)} aria-label="Previous Image" className="absolute left-2 sm:left-6 z-10 w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-[#0F1C2E]/80 border border-white/20 text-[#F4EFE6] hover:bg-[#DF6D2A] hover:border-[#DF6D2A] transition-all active:scale-95 shadow-xl"><ChevronLeft size={20} strokeWidth={2} className="sm:w-6 sm:h-6" /></button>;
    $[33] = currentIndex;
    $[34] = images.length;
    $[35] = onNavigate;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  let t23;
  let t24;
  let t25;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      opacity: 0,
      scale: 0.96
    };
    t23 = {
      opacity: 1,
      scale: 1
    };
    t24 = {
      opacity: 0,
      scale: 0.96
    };
    t25 = {
      duration: 0.2
    };
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
    $[40] = t25;
  } else {
    t22 = $[37];
    t23 = $[38];
    t24 = $[39];
    t25 = $[40];
  }
  const t26 = encodeURI(currentImage);
  const t27 = `${sectionTitle} - Image ${currentIndex + 1}`;
  let t28;
  if ($[41] !== t26 || $[42] !== t27) {
    t28 = <img src={t26} alt={t27} className="max-h-[75vh] sm:max-h-[78vh] max-w-[92vw] sm:max-w-[90vw] object-contain rounded border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)]" />;
    $[41] = t26;
    $[42] = t27;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== currentIndex || $[45] !== t28) {
    t29 = <motion.div key={currentIndex} initial={t22} animate={t23} exit={t24} transition={t25} className="max-w-full max-h-full flex items-center justify-center relative">{t28}</motion.div>;
    $[44] = currentIndex;
    $[45] = t28;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== currentIndex || $[48] !== images.length || $[49] !== onNavigate) {
    t30 = images.length > 1 && <button onClick={() => onNavigate((currentIndex + 1) % images.length)} aria-label="Next Image" className="absolute right-2 sm:right-6 z-10 w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-[#0F1C2E]/80 border border-white/20 text-[#F4EFE6] hover:bg-[#DF6D2A] hover:border-[#DF6D2A] transition-all active:scale-95 shadow-xl"><ChevronRight size={20} strokeWidth={2} className="sm:w-6 sm:h-6" /></button>;
    $[47] = currentIndex;
    $[48] = images.length;
    $[49] = onNavigate;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== handleTouchEnd || $[52] !== t21 || $[53] !== t29 || $[54] !== t30) {
    t31 = <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} className="relative flex-1 flex items-center justify-center p-3 sm:p-8 overflow-hidden touch-pan-y">{t21}{t29}{t30}</div>;
    $[51] = handleTouchEnd;
    $[52] = t21;
    $[53] = t29;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== currentIndex || $[57] !== images || $[58] !== onNavigate) {
    t32 = images.length > 1 && <div className="px-3 sm:px-6 py-2.5 border-t border-white/10 bg-[#0F1C2E]/95 flex items-center justify-start sm:justify-center gap-2 overflow-x-auto scrollbar-none z-10">{images.map((img, idx) => <button key={idx} onClick={() => onNavigate(idx)} className={`relative h-11 w-14 sm:h-14 sm:w-20 rounded overflow-hidden flex-shrink-0 border-2 transition-all ${idx === currentIndex ? "border-[#DF6D2A] scale-105 opacity-100" : "border-transparent opacity-40 hover:opacity-80"}`}><img src={encodeURI(img)} alt={`Thumb ${idx + 1}`} className="w-full h-full object-cover" /></button>)}</div>;
    $[56] = currentIndex;
    $[57] = images;
    $[58] = onNavigate;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t20 || $[61] !== t31 || $[62] !== t32) {
    t33 = <AnimatePresence><motion.div initial={t10} animate={t11} exit={t12} transition={t13} className="fixed inset-0 z-[2000] bg-[#0F1C2E]/95 backdrop-blur-md flex flex-col justify-between select-none">{t20}{t31}{t32}</motion.div></AnimatePresence>;
    $[60] = t20;
    $[61] = t31;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  return t33;
}